import { pages } from '@/entities/current-page';
import {
  ClientAndPartnersIcon,
  FinancesIcon,
  HomePageIcon,
  LogoutIcon,
  OrdersIcon,
  ProductsAndOffersIcon,
  ResourcesIcon,
  UserIcon,
  PenaltiesIcon,
} from '@/shared/ui/icons';

export const MainMenuItems = [
  {
    name: 'Головна',
    page: pages.HOME,
    route: { name: 'prime' },
    icon: HomePageIcon,
    available: true,
  },
  {
    group: 'finance',
    name: 'Фінанси',
    page: pages.FINANCE,
    icon: FinancesIcon,
    available: ({ userInfo }) => userInfo?.isAgent,
    subitems: [
      {
        name: 'Історія транзакцій',
        route: { name: 'score' },
        available: ({ userInfo }) => userInfo?.isAgent,
      },
    ],
  },
  {
    group: 'orders',
    name: 'Замовлення',
    page: pages.ORDERS,
    icon: OrdersIcon,
    available: true,
    subitems: [
      {
        name: 'Пролонгація',
        route: { name: 'prolongation' },
        available: true,
      },
      {
        name: 'Історія замовлень',
        route: { name: 'history' },
        available: true,
      },
      {
        name: 'Запити на ануляцію',
        route: { name: 'cancellation' },
        available: true,
      },
      {
        name: 'Запити на переоформлення',
        route: { name: 'reissue' },
        available: true,
      },
      /*{
        name: 'Сторінки пропозицій',
        route: { name: 'propositions' },
        available: ({ userInfo }) => !userInfo?.isBankPartner,
      },*/
      {
        name: 'Центр котирування',
        route: { name: 'quotations' },
        available: true,
      },
    ],
  },
  {
    group: 'products-and-offers',
    name: 'Продукти та пропозиції',
    page: pages.PRODUCTS_AND_PROPOSITIONS,
    icon: ProductsAndOffersIcon,
    available: true,
    subitems: [
      {
        name: 'Страхові продукти',
        route: { name: 'products' },
        available: ({ userInfo }) => !userInfo?.isBankPartner,
      },
    ],
  },
  {
    group: 'client-and-partners',
    name: 'Клієнти та партнери',
    page: pages.CLIENTS_AND_PARTNERS,
    icon: ClientAndPartnersIcon,
    available: true,
    subitems: [
      {
        name: 'Клієнти',
        route: { name: 'clients' },
        available: true,
      },
      {
        name: 'Точки продажу',
        route: { name: 'partners' },
        available: ({ userInfo }) => userInfo?.isMainPartner || userInfo?.isBankPartner,
      },
      {
        name: 'Реферали',
        route: { name: 'referrals' },
        available: ({ userInfo }) => userInfo?.isMainPartner && !userInfo?.isBankPartner,
      },
      {
        name: 'Головні установи',
        route: { name: 'organizations' },
        available: ({ userInfo }) => userInfo?.organizationId && userInfo?.isHeadOrganization,
      },
    ],
  },
  {
    group: 'resources',
    name: 'Ресурси',
    page: pages.RESOURCES,
    icon: ResourcesIcon,
    available: true,
    subitems: [
      {
        name: 'База знань',
        route: { name: 'knowledgeBase' },
        available: ({ userInfo }) => !userInfo?.isBankPartner,
      },
      {
        name: 'Новини',
        route: { name: 'news' },
        available: ({ userInfo }) => !userInfo?.isBankPartner,
      },
      {
        name: 'Мій Telegram-бот',
        route: { name: 'telegramBot' },
        available: ({ userInfo }) => !userInfo?.isBankPartner,
      },
    ]
  },
  {
    group: 'penalties',
    name: 'Штрафи',
    page: pages.PENALTIES,
    icon: PenaltiesIcon,
    available: ({ userInfo }) => userInfo?.isActivePenalty,
    route: {name: 'penalties'}
  },
  {
    name: 'Профіль',
    route: { name: 'profile' },
    icon: UserIcon,
    available: ({ windowSize }) => !windowSize.isDesktop,
  },
  {
    name: 'Вийти',
    event: 'logout',
    icon: LogoutIcon,
    available: ({ windowSize }) => !windowSize.isDesktop,
  },
];
